import { render, staticRenderFns } from "./CardProductCourse.vue?vue&type=template&id=617a3654&scoped=true"
import script from "./CardProductCourse.vue?vue&type=script&lang=js"
export * from "./CardProductCourse.vue?vue&type=script&lang=js"
import style0 from "./CardProductCourse.vue?vue&type=style&index=0&id=617a3654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a3654",
  null
  
)

export default component.exports